import { IPermissionDetail } from '../../../services/rolesAndPermissions/rolesAndPermissions.types';

export enum PermissionActivity {
  active,
  inActive,
  all,
}

export interface IPermissionsListProps {
  permissions: IPermissionDetail[];
  onTogglePermissionActivity: (permissionId: string) => void;
  withSearchResults?: boolean;
}
